import { getServerApi } from '@/gql';
import { MessageQuota } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import { useEffect, useState } from 'react';

export interface UseMessageQuotaResult {
    messageQuota: MessageQuota | null;
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<MessageQuota | null>;
}

export const useMessageQuota = (tokenId: number): UseMessageQuotaResult => {
    const [messageQuota, setMessageQuota] = useState<MessageQuota | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getMessageQuota = async () => {
        if (!tokenId || !userId) {
            setMessageQuota(null);
            return null;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.messageQuota({
                tokenId,
            });
            if (response?.messageQuota !== undefined) {
                setMessageQuota(response.messageQuota);
                return response.messageQuota;
            } else {
                setMessageQuota(null);
                return null;
            }
        } catch (err) {
            console.error('Failed to fetch message quota:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch message quota'),
            );
            setMessageQuota(null);
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getMessageQuota();
    }, [tokenId, userId]);

    return {
        messageQuota,
        loading,
        error,
        refetch: getMessageQuota,
    };
};
